(function () {
  'use strict';
  if (typeof IntersectionObserver === 'undefined') return;

  // Scroll reveal on craft + gift + reviews
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('in-view');
    });
  }, { threshold: 0.10, rootMargin: '0px 0px -60px 0px' });

  function initReveal() {
    ['.ihe-craft-inner', '.ihe-gift-content', '.ihe-gift-image', '.ihe-reviews-inner'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        observer.observe(el);
        setTimeout(function () { el.classList.add('in-view'); }, 1800);
      });
    });
  }

  // Parallax on the .ihe-craft background
  var parallaxTargets = [];
  var ticking = false;
  function updateParallax() {
    var winH = window.innerHeight;
    parallaxTargets.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < winH) {
        var yOffset = (rect.top - winH * 0.5) * -0.35;
        el.style.backgroundPositionY = 'calc(50% + ' + yOffset + 'px)';
      }
    });
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { window.requestAnimationFrame(updateParallax); ticking = true; }
  }
  function initParallax() {
    // Parallax on small screens shifts the bg and exposes an empty band — desktop only
    if (window.innerWidth < 750) return;
    parallaxTargets = Array.prototype.slice.call(document.querySelectorAll('.ihe-craft'));
    if (!parallaxTargets.length) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    updateParallax();
  }

  // Swap the 32px logo source for a 2x version so the CSS upscale stays crisp
  function upgradeLogo() {
    document.querySelectorAll('.header-logo img, .header-logo__image-container img').forEach(function (img) {
      if (img.src.indexOf('height=32') !== -1) {
        img.src = img.src.replace('height=32', 'height=92');
        img.removeAttribute('srcset');
      }
    });
  }

  // Inject "Shop Our Products" CTA in the s_craft section
  function injectCraftCTA() {
    var inner = document.querySelector('.ihe-craft-inner');
    if (!inner || inner.querySelector('.ihe-craft-cta')) return;
    var cta = document.createElement('a');
    cta.href = '/collections/all?sort_by=best-selling';
    cta.className = 'ihe-craft-cta';
    cta.textContent = 'Shop Our Products';
    inner.appendChild(cta);
  }

  function init() {
    initReveal();
    initParallax();
    injectCraftCTA();
    upgradeLogo();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
